import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getIngestDiff, IIngestDiffResponse } from 'src/api/getIngestDiff';
import { getIngestDiffQueryKey } from '../QueryKeys';

interface IUseIngestDiffOptions {
  enabled?: boolean;
}

/**
 * Fetches the diff for an ingest event.
 *
 * A diff is immutable for a given event and can be large, so it is never refetched once loaded, and
 * errors surface inline in the review modal rather than as a snackbar.
 */
export const useIngestDiff = (
  eventId?: string,
  { enabled = true }: IUseIngestDiffOptions = {},
): UseQueryResult<IIngestDiffResponse | null> =>
  useQuery<IIngestDiffResponse | null>({
    queryKey: getIngestDiffQueryKey(eventId),
    queryFn: () => getIngestDiff(eventId as string),
    enabled: !!eventId && enabled,
    staleTime: Infinity,
    retry: false,
  });
